const images = [
    { description: 'Kitchen view 1', src: 'IMG_1653.jpg'},
    { description: 'Kitchen view 2', src: 'IMG_1653.jpg'},
    { description: 'Master Bedroom', src: 'IMG_1716.jpg'},
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'},     
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Kitchen view 2', src: 'IMG_1653.jpg'},
    { description: 'Master Bedroom', src: 'IMG_1716.jpg'},     
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'}, 
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Master Bedroom', src: 'IMG_1715.jpg'}, 
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Kitchen view 1', src: 'IMG_1653.jpg'},
    { description: 'Kitchen view 2', src: 'IMG_1716.jpg'},
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'}, 
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Kitchen view 1', src: 'IMG_1653.jpg'},
    { description: 'Kitchen view 2', src: 'IMG_1716.jpg'},
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'}, 
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'}, 
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Kitchen view 1', src: 'IMG_1653.jpg'},
    { description: 'Kitchen view 2', src: 'IMG_1716.jpg'},
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'}, 
    { description: 'Kitchen view 1', src: 'IMG_1654.jpg'},
    { description: 'Kitchen view 2', src: 'IMG_1653.jpg'},
    { description: 'Master Bedroom', src: 'IMG_1716.jpg'},
    { description: 'Master Bathroom', src: 'IMG_1715.jpg'}
    
];

export default images;